import React from 'react';
import classNames from 'classnames';
import { Checkbox } from '@atlaskit/checkbox';

export default class Item extends React.Component {
  toggle = () => this.props.toggle(this.props.item);

  render() {
    return (
      <div
        className={classNames('grouped-item', {
          active: this.props.item.selected,
        })}
      >
        <Checkbox
          onChange={this.toggle}
          isChecked={this.props.item.selected}
          label={
            <span className="grouped-item-label component-toggle">
              {this.props.item.name}
            </span>
          }
        />
        <span style={{ display: 'none' }}>{this.props.item.id}</span>
      </div>
    );
  }
}
